import InstitutionService from '../../service/institution';

const Action = {
    NEW_INSTITUTION: "NEW_INSTITUTION",
    GET_INSTITUTION: "GET_INSTITUTION",
    GET_INSTITUTIONS: "GET_INSTITUTIONS",
};

const ActionCreator = {
    newInstitution(institution) {
        return async (dispatch) => {
            try {
                const newInstitution = await InstitutionService.add(institution);
                dispatch({type: Action.NEW_INSTITUTION, institution: newInstitution});
                return newInstitution;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getInstitution(institutionId) {
        return async (dispatch) => {
            try {
                const institution = await InstitutionService.findById(institutionId);
                dispatch({type: Action.GET_INSTITUTION, institution});
                return institution;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
    getInstitutions() {
        return async (dispatch) => {
            try {
                const institutions = await InstitutionService.list();
                dispatch({type: Action.GET_INSTITUTIONS, institutions});
                return institutions;
            } catch (error) {
                throw dispatch({error});
            }
        };
    },
};

const initialState = {
    list: [],
    institution: {},
};

const Reducer = function (state = initialState, action) {
    switch (action.type) {
        case Action.NEW_INSTITUTION:
            return {
                ...state,
                institution: action.institution
            };
        case Action.GET_INSTITUTION:
            return {
                ...state,
                institution: action.institution
            };
        case Action.GET_INSTITUTIONS:
            return {
                ...state,
                list: action.institutions
            };
        default: {
            return state;
        }
    }
};

export default {Action, ActionCreator, Reducer};



// WEBPACK FOOTER //
// ./src/store/actionreducers/institution.js